export default __webpack_public_path__ + "static/media/brainfeed.8c7db831.jpeg";